import { gql, useMutation } from "@apollo/client";

export const CREATE_TRANSACTIONS_FILE_IMPORT = gql`
  mutation CreateTransactionsFileImport($input: [TransactionCreateInput!]) {
    createTransactionsFileImport(input: $input)
  }
`;

export const useCreateTransactionsFileImport = () => {
  const [mutate, state] = useMutation(CREATE_TRANSACTIONS_FILE_IMPORT);
  return { createTransactionsFileImport: mutate, ...state } as const;
};
